import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';

import { URL_API } from '../constante';
import {HEADERS} from './../constante';
import {AcessoService} from "../acesso/acesso.service";
import {Utils} from '../shared/utils';

@Injectable()
export class RecuperarSenhaService {

  private headers = new Headers();
  private url = URL_API + '/senha';

  constructor(private http: Http, private acessoService: AcessoService,
			  private utils: Utils) {
    this.headers.append('Content-Type', 'multipart/form-data');
    this.headers.append('Accept', 'application/json; text/plain, */*');
  }


  solicitarRecuperacao(dados_recuperar): Observable<any> {
    return this.http.post(this.url+'/recuperar', dados_recuperar, {headers: HEADERS})
                .map(response => response.json())
                .catch((error) => this.utils.handleError(error));
  }

  atualizarSenha(dados_recuperar): Observable<any> {
    return this.http.post(this.url+'/nova', dados_recuperar, {headers: HEADERS})
                .map(response => response.json())
                .catch((error) => this.utils.handleError(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/recuperar-senha/recuperar-senha.service.ts